<template>
  <div>
    <div style='width:350px; margin: 0 auto'>
      <div style='text-align: center; margin-bottom: 10px; font-size:2.0rem; font-weight:bold;'> {{qrOptions.title}}</div>
      <div class='qr-code-wrap' style='margin: 0 auto'>
        <QRCanvas class='qr-code'  :options="getQrOptions" @updated="onQrUpdated"></QRCanvas>
      </div>
      <div class='dx-field' style='text-align:center;margin:20px auto 0 auto;width:250px;'>
        <div class="float-left">
          <DxNumberBox
            :value.sync="printQrCount"
            :min="1"
            :max="10"
            width='70'
            :show-spin-buttons="true"
            :show-clear-button='false'
            placeholder='출력매수'
          />
        </div>
        <div class="float-left" style='margin-top:1px;margin-left:10px;'>
          <DxButton
            text='프린트'
            type='danger'
            width='80'
            @click="onPrintQrcode"
          />
        </div>
        <div class="float-left" style='margin-top:1px;margin-left:10px;'>
          <DxButton
            text='프린팅 결과'
            type='default'
            width='80'
            @click="onPrintResult"
          />
        </div>
      </div>
    </div>
    <div class="printing-result" style="margin-top:10px;">
      <dx-data-grid
        ref="refPrintResult"
        :data-source='printingResultInfo'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='200' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        :auto-navigate-to-focused-row="false"
        key-expr="seqId"
        @row-updated='onRowUpdated' @row-updating="onRowUpdating"
      >
        <DxEditing
            :allow-deleting="false"
            :allow-updating="true"
            :allow-adding="false"
            :use-icons="true"
            mode='row'
          >
        </DxEditing>
        <DxColumn
          :allowEditing='false'
          caption="프린터명"
          data-field="프린터명"
          :visible='true'
          sort-order="asc"
          width="90"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="QR코드"
          data-field="문자"
          :visible='true'
          width="140"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="매수"
          data-field="장수"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="완료"
          data-field="완료"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          width="70"
          :buttons="editButtons"
          type="buttons"
        />
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
    </div>
    <div style="margin-top:10px;">
      <dx-data-grid
        :data-source='zebraInfo'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        height='100' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        @focused-row-changed="onSelectionChangedZebra"
        :auto-navigate-to-focused-row="false"
        :focused-row-key.sync='focusedRowKey'
        key-expr="seqId"
      >
        <DxColumn
          :allowEditing='true'
          caption="지역"
          data-field="지역"
          :visible='true'
          sort-order="asc"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="프린터명"
          data-field="프린터명"
          :visible='true'
          sort-order="asc"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="라벨형식"
          data-field="라벨형식"
          :visible='true'
          :min-width="150"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="주소"
          data-field="프린터주소"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="포트"
          data-field="포워딩포트"
          :visible='true'
        >
        </DxColumn>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
    </div>
  </div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxEditing,
  DxColumn, DxPaging, DxSorting } from 'devextreme-vue/data-grid'
import { DxButton } from 'devextreme-vue'
// import AesCrypto from '../../share/service/AesCrypto'
import DxNumberBox from 'devextreme-vue/number-box'
import HttpService from '../../share/service/HttpService'
const { QRCanvas } = require('qrcanvas-vue')

export default {
  name: 'login',
  props: {
    qrOptions: Object
  },
  data: function () {
    return {
      userInfo: null,
      popupQrcode: false,
      printQrCount: 10,
      // zebra info
      zebraInfo: null,
      selectedZebraInfo: null,
      focusedRowKey: null,
      editButtons: [ 'edit',
        {
          hint: '부품식별표 프린트',
          icon: 'print',
          visible: 'true',
          onClick: this.onClickRePrint
        }],
      printingResultInfo: null
    }
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxSorting,
    DxScrolling,
    DxEditing,
    QRCanvas,
    DxButton,
    DxNumberBox
  },
  computed: {
    getQrOptions () {
      return this.qrOptions
    }
  },
  created () {
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.refreshZebraInfo()
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    refreshZebraInfo () {
      this.$_sp.runNoEncodeFindProc('spFindAllPrinterList', {})
        .then((data) => {
          this.zebraInfo = this.$_sp.MakeModel(data)
          if (this.zebraInfo.length === 1) {
            this.focusedRowKey = this.zebraInfo[0].seqId
          }
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onPrintQrcode () {
      if (this.selectedZebraInfo === null) {
        this.$snotify.info('출혁 할 프린터 정보를 선택하여 주세요.')
        return
      }
      this.$snotify.confirm(`${this.selectedZebraInfo.프린터명}로 (${this.printQrCount}매) 프린팅 하시겠습니까?`, '', {
        timeout: 10000,
        showProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        buttons: [
          { text: '프린트',
            action: (toast) => {
              this.$snotify.remove(toast.id)
              this.printQrcode(this.qrOptions.title, this.printQrCount)
            }
          },
          { text: '취소',
            action: (toast) => { this.$snotify.remove(toast.id) }
          }
        ]
      })
    },
    onQrUpdated (e) {
      this.$Q('.qr-code-wrap').css('width', e.width + 'px')
    },
    async printQrcode (pCode, count) {
      this.isLoading = true
      let pInfo = null
      await this.$_sp.runNoEncodeFindProc('spFindAllProductInfoJoinCompany', { 품번: pCode })
        .then((data) => {
          pInfo = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
      const 창고관리 = this.$_.findWhere(this.$store.getters.getSysParam, { key: '창고관리' }).value
      if (pInfo === null || pInfo.length === 0) {
        this.isLoading = false
        this.$snotify.error(`${pCode} 정보를 검색할 수 없습니다.`)
        return
      } else if (pInfo[0].품목유형 === ConstDef.구매품 && pInfo[0].자재유형 !== ConstDef.외주직납품 &&
        창고관리 === 'false' && pInfo[0].자재유형 !== ConstDef.외주품 && pInfo[0].자재유형 !== ConstDef.사급품) {
        this.isLoading = false
        this.$snotify.error('일반구매품 부품식별표는 출력할 필요가 없습니다.')
        return
      }
      let param = {
        품번: pCode,
        count: count,
        createid: this.userInfo.userName,
        createtime: AppLib.getNow()
      }
      await this.$_sp.runUpdateProc('spCreateGoodsQrCodeSerialNo', [param])
        .then((data) => {
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
      if (this.isLoading === false) {
        this.$snotify.error('부품식별표 발행 요청 실패하였습니다.')
        return
      }
      delete param.count
      let qrList = null
      await this.$_sp.runNoEncodeFindProc('spFindAllInputQrcode', param)
        .then((data) => {
          qrList = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
      if (this.isLoading === false) {
        this.$snotify.error('부품식별표 생성 요청 실패하였습니다.')
        return
      }
      // TODO QRCODE Print 요청
      let printList = []
      let zpl = null
      let year = AppLib.getToday().substring(1, 4)
      // 사이즈변경시 unremrk
      // year = ''
      for (let i = 0; i < qrList.length; i++) {
        const base64 = `${qrList[i].품번}/${qrList[i].seqId}${year}`
        zpl = await this.mkaeZpl(pInfo[0], base64, `${qrList[i].seqId}${year}`, this.selectedZebraInfo.zpl)
        const temp = {
          지역: this.selectedZebraInfo.지역,
          프린터명: this.selectedZebraInfo.프린터명,
          프린터주소: this.selectedZebraInfo.프린터주소,
          포워딩포트: this.selectedZebraInfo.포워딩포트,
          qrCode: base64,
          문자: `${qrList[i].품번}/${qrList[i].seqId}`,
          문자2: `${qrList[i].품명}`,
          장수: 1,
          완료: !ConstDef.QR_PRINT,
          zpl: zpl,
          사용유무: 0,
          createid: this.userInfo.userName,
          updateid: this.userInfo.userName
        }
        printList.push(temp)
      }
      await this.$_sp.runInsertSqlProc('프린팅대기', null, printList)
        .then((data) => {
          this.$snotify.info('부품식별표 프린팅 요청하였습니다.')
          HttpService.reqPost(JSON.stringify({ printName: this.selectedZebraInfo.프린터명 }), '/qrCodePrinting')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
      this.isLoading = false
    },
    async mkaeZpl (pInfo, qrCode, seqId, zpl) {
      let carType = null
      if (pInfo.차종 === null) {
        carType = await this.searchCarType(pInfo.품번)
      } else {
        carType = pInfo.차종
      }
      // zpl = ConstDef.ALL_PRODUCT_ZPL
      // zpl = this.$_.findWhere(this.$store.getters.getSysParam, { key: 'ZPL_TYPE2' }).value
      zpl = AppLib.replaceAll(zpl, '{{PROCESSING_NAME}}', pInfo.설명)
      zpl = AppLib.replaceAll(zpl, '{{GOODS_NO}}', pInfo.품번)
      zpl = AppLib.replaceAll(zpl, '{{GOODS_NAME}}', pInfo.품명)
      zpl = AppLib.replaceAll(zpl, '{{LOT_NO}}', seqId)
      zpl = AppLib.replaceAll(zpl, '{{QRCODE}}', qrCode)
      zpl = AppLib.replaceAll(zpl, '{{CAR_TYPE}}', carType)
      // console.log('***********', qrCode.length)
      if (qrCode.length <= 24) {
        zpl = AppLib.replaceAll(zpl, '{{QR_SIZE}}', 7)
      } else {
        console.log('siz=6')
        zpl = AppLib.replaceAll(zpl, '{{QR_SIZE}}', 6)
      }
      // if (zpl !== null) {
      //   if (pInfo.품명.length < 20) {
      //     zpl = AppLib.replaceAll(zpl, '{{GOODS_NMAE_FONT}}', '90')
      //   } else if (pInfo.품명.length < 29) {
      //     zpl = AppLib.replaceAll(zpl, '{{GOODS_NMAE_FONT}}', '65')
      //   } else {
      //     zpl = AppLib.replaceAll(zpl, '{{GOODS_NMAE_FONT}}', '45')
      //   }
      // }
      // 사이즈변경시 unremrk 상단 remark

      if (zpl !== null) {
        if (pInfo.품명.length < 20) {
          zpl = AppLib.replaceAll(zpl, '{{GOODS_NMAE_FONT}}', '43')
        } else if (pInfo.품명.length < 27) {
          zpl = AppLib.replaceAll(zpl, '{{GOODS_NMAE_FONT}}', '35')
        } else if (pInfo.품명.length < 33) {
          zpl = AppLib.replaceAll(zpl, '{{GOODS_NMAE_FONT}}', '27')
        } else {
          zpl = AppLib.replaceAll(zpl, '{{GOODS_NMAE_FONT}}', '25')
        }
      }
      return zpl
    },
    async searchCarType (pCode) {
      let carType = ''
      await this.$_sp.runNoEncodeFindProc('spFindAllCarTypeByPcode', { 품번: pCode })
        .then((data) => {
          const result = this.$_sp.MakeModel(data)
          for (let i = 0; i < result.length; i++) {
            carType += result[i].차종
            if (i < result.length - 1) {
              carType += '/'
            }
          }
        })

      return carType
    },
    // print result
    onClickRePrint (e) {
      if (e.row.data.완료 >= e.row.data.장수) {
        this.$snotify.info('완료 매수가 출력요청 매수 보다 작게 수정후 재출력하여 주세요.')
        return
      }
      HttpService.reqPost(JSON.stringify({ printName: this.selectedZebraInfo.프린터명 }), '/qrCodePrinting')
      this.$snotify.info('QR Code 재 프린팅 요청하였습니다.')
      this.$Q('.printing-result').hide()
    },
    onPrintResult () {
      let status = this.$Q('.printing-result').css('display')
      if (status !== 'none') {
        this.$Q('.printing-result').hide()
        return
      }
      this.$Q('.printing-result').show()
      this.$_sp.runNoEncodeFindProc('spFindAllPrintingResult', { createid: this.userInfo.userName })
        .then((data) => {
          this.printingResultInfo = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowUpdated (row) {
      row.data.updatetime = AppLib.getNow()
      this.$_sp.runUpdateSqlProc('프린팅대기', ['seqId'], null, [row.data])
        .then((data) => {
          this.$snotify.info('프린트 아이콘을 클릭하여 재출력하여 주세요.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowUpdating (row) {
      if (row.newData.완료 >= row.oldData.장수) {
        this.$snotify.info('완료 매수가 출력요청 매수 보다 작아야 합니다.')
        row.cancel = true
      }
    },
    // zebran grid
    onSelectionChangedZebra (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedZebraInfo = e.row.data
      }
    }

  }
}
</script>

<style lang="scss">
.printing-result {
  display: none;
}
</style>
